// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"3718dc34","76":"be458774","488":"5a722a8b"}[chunkId] + ".chunk.js";
};